<template>
  <nav class="navbar navbar-expand-lg navbar-dark modern-navbar">
    <div class="container-fluid">
      <router-link to="/" class="navbar-brand modern-brand">
        <div class="brand-icon">
          <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8.111 1.056a.5.5 0 0 0-.222 0l-7 3a.5.5 0 0 0 0 .888l.732.314v6.002a.5.5 0 0 0 .268.446l6 3a.5.5 0 0 0 .446 0l6-3a.5.5 0 0 0 .268-.446V5.258l.732-.314a.5.5 0 0 0 0-.888zM8 2.213 14.28 4.9 8 7.587 1.72 4.9z"/>
          </svg>
        </div>
        <span class="brand-text">职业健康智能题库</span>
      </router-link>
      <span class="brand-family">职卫云旗下 · <ExternalBrandLink surface="navbarBrand" aria-label="在新窗口打开职卫云官网（导航）" /></span>

      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-container d-lg-none">
        <!-- 题库中心浮动菜单 -->
        <div class="mobile-dropdown" v-if="authStore.isAuthenticated" ref="questionBankMenuRef">
          <button 
            class="mobile-menu-btn"
            @click="toggleQuestionBankMenu"
            :class="{ active: isQuestionBankMenuOpen }"
          >
            <i class="bi bi-journal-text"></i>
          </button>
        </div>
        
        <!-- 更多菜单浮动按钮 -->
        <div class="mobile-dropdown" ref="mainMenuRef">
          <button 
            class="mobile-menu-btn" 
            @click="toggleMainMenu"
            :class="{ active: isMainMenuOpen }"
          >
            <i class="bi bi-three-dots"></i>
          </button>
        </div>
      </div>

    <!-- 使用Teleport将浮动菜单渲染到body -->
    <Teleport to="body">
      <!-- 题库中心浮动菜单 -->
      <div 
        v-if="authStore.isAuthenticated && isQuestionBankMenuOpen" 
        class="mobile-dropdown-menu teleport-menu" 
        :style="questionBankMenuStyle"
      >
        <router-link to="/quiz" class="mobile-dropdown-item" @click="closeAllMenus">
          <i class="bi bi-journal-text me-2"></i>
          题库练习
        </router-link>
        <router-link to="/exam" class="mobile-dropdown-item" @click="closeAllMenus">
          <i class="bi bi-clock me-2"></i>
          模拟考试
        </router-link>
        <router-link to="/wrong-questions" class="mobile-dropdown-item" @click="closeAllMenus">
          <i class="bi bi-x-circle me-2"></i>
          错题本
        </router-link>
        <router-link to="/quiz/history" class="mobile-dropdown-item" @click="closeAllMenus">
          <i class="bi bi-clock-history me-2"></i>
          练习记录
        </router-link>
      </div>
      
      <!-- 主菜单浮动下拉 -->
      <div 
        v-if="isMainMenuOpen" 
        class="mobile-dropdown-menu main-menu teleport-menu" 
        :style="mainMenuStyle"
      >
        <router-link to="/" class="mobile-dropdown-item" @click="closeAllMenus">
          <i class="bi bi-house-door me-2"></i>
          首页
        </router-link>
        <router-link to="/admin" class="mobile-dropdown-item" v-if="authStore.isAdmin" @click="closeAllMenus">
          <i class="bi bi-gear me-2"></i>
          系统管理
        </router-link>
        <router-link to="/profile" class="mobile-dropdown-item" v-if="authStore.isAuthenticated" @click="closeAllMenus"><i class="bi bi-person me-2"></i>个人中心</router-link>
        <router-link to="/invite" class="mobile-dropdown-item" v-if="authStore.isAuthenticated" @click="closeAllMenus"><i class="bi bi-gift me-2"></i>邀请有礼</router-link>
        <router-link to="/feedbacks" class="mobile-dropdown-item" v-if="authStore.isAuthenticated" @click="closeAllMenus"><i class="bi bi-chat-square-text me-2"></i>反馈管理</router-link>
        <router-link to="/login" class="mobile-dropdown-item" v-if="!authStore.isAuthenticated" @click="closeAllMenus">
          <i class="bi bi-box-arrow-in-right me-2"></i>
          登录
        </router-link>
        <router-link to="/register" class="mobile-dropdown-item" v-if="!authStore.isAuthenticated" @click="closeAllMenus">
          <i class="bi bi-person-plus me-2"></i>
          注册
        </router-link>
        <div class="mobile-dropdown-item user-info" v-if="authStore.isAuthenticated">
          <img 
            v-if="getUserAvatar" 
            :src="getUserAvatar" 
            :alt="getUserDisplayName"
            class="user-avatar me-2"
            @error="handleAvatarError"
          />
          <span>{{ getUserDisplayName }}</span>
        </div>
        <button class="mobile-dropdown-item logout-btn" v-if="authStore.isAuthenticated" @click="logout">
          <i class="bi bi-box-arrow-right me-2"></i>
          退出登录
        </button>
      </div>
    </Teleport>

      <!-- 桌面端菜单保持不变 -->
      <div class="collapse navbar-collapse d-none d-lg-block" id="navbarNav">
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <router-link to="/" class="nav-link" active-class="active" exact>
              <i class="bi bi-house-door me-1"></i>
              首页
            </router-link>
          </li>
          
          <!-- 题库管理 -->
          <li class="nav-item dropdown" v-if="authStore.isAuthenticated">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              <i class="bi bi-journal-text me-1"></i>
              题库中心
            </a>
            <ul class="dropdown-menu">
              <li>
                <router-link to="/quiz" class="dropdown-item">
                  <i class="bi bi-journal-text me-2"></i>
                  题库练习
                </router-link>
              </li>
              <li>
                <router-link to="/exam" class="dropdown-item">
                  <i class="bi bi-clock me-2"></i>
                  模拟考试
                </router-link>
              </li>
              <li>
                <router-link to="/wrong-questions" class="dropdown-item">
                  <i class="bi bi-x-circle me-2"></i>
                  错题本
                </router-link>
              </li>
              <li>
                <router-link to="/quiz/history" class="dropdown-item">
                  <i class="bi bi-clock-history me-2"></i>
                  练习记录
                </router-link>
              </li>
            </ul>
          </li>
          
          <!-- 管理员菜单 -->
          <li class="nav-item" v-if="authStore.isAdmin">
            <router-link to="/admin" class="nav-link" active-class="active">
              <i class="bi bi-gear me-1"></i>
              系统管理
            </router-link>
          </li>
          
          <!-- 个人中心 -->
          <li class="nav-item" v-if="authStore.isAuthenticated"><router-link to="/invite" class="nav-link" active-class="active"><i class="bi bi-gift me-1"></i>邀请有礼</router-link></li>
          <li class="nav-item" v-if="authStore.isAuthenticated"><router-link to="/feedbacks" class="nav-link" active-class="active"><i class="bi bi-chat-square-text me-1"></i>反馈管理</router-link></li>
          <li class="nav-item" v-if="authStore.isAuthenticated"><router-link to="/profile" class="nav-link" active-class="active"><i class="bi bi-person me-1"></i>个人中心</router-link></li>
        </ul>

        <ul class="navbar-nav ms-auto">
          <li class="nav-item" v-if="!authStore.isAuthenticated">
            <router-link to="/login" class="nav-link">
              <i class="bi bi-box-arrow-in-right me-1"></i>
              登录
            </router-link>
          </li>
          <li class="nav-item" v-if="!authStore.isAuthenticated">
            <router-link to="/register" class="nav-link">
              <i class="bi bi-person-plus me-1"></i>
              注册
            </router-link>
          </li>
          
          <!-- 已登录状态显示用户信息和退出 -->
          <li class="nav-item" v-if="authStore.isAuthenticated">
            <span class="nav-link d-flex align-items-center" style="cursor: default">
              <!-- 显示用户头像或默认图标 -->
              <img 
                v-if="getUserAvatar" 
                :src="getUserAvatar" 
                :alt="getUserDisplayName"
                class="user-avatar me-2"
                @error="handleAvatarError"
              />
              <i v-else class="bi bi-person-circle me-1"></i>
              {{ getUserDisplayName }}
            </span>
          </li>
          <li class="nav-item" v-if="authStore.isAuthenticated">
            <button class="nav-link btn btn-link" @click="logout"
              style="cursor: pointer; border: none; background: none; padding: 0.5rem 1rem"
            >
              <i class="bi bi-box-arrow-right me-1"></i>
              退出登录
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '../../stores/auth'
import ExternalBrandLink from '../recommendations/ExternalBrandLink.vue'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

// 响应式状态
const isMenuOpen = ref(false)
const isQuestionBankMenuOpen = ref(false) // 题库中心菜单状态
const isMainMenuOpen = ref(false) // 主菜单状态

// 菜单按钮的ref引用
const questionBankMenuRef = ref<HTMLElement>()
const mainMenuRef = ref<HTMLElement>()

// 菜单位置样式
const questionBankMenuStyle = ref({})
const mainMenuStyle = ref({})

// 计算属性
const isAuthenticated = computed(() => authStore.isAuthenticated)
const user = computed(() => authStore.user)
const isAdmin = computed(() => authStore.isAdmin)

// 获取用户显示名称
const getUserDisplayName = computed(() => {
  if (!user.value) return ''
  
  // 优先显示微信昵称
  if (user.value.wechatNickname) {
    return user.value.wechatNickname
  }
  
  // 其次显示姓名
  if (user.value.firstName && user.value.lastName) {
    return `${user.value.firstName}${user.value.lastName}`
  }
  
  // 最后显示用户名
  return user.value.username
})

// 获取用户头像
const getUserAvatar = computed(() => {
  const name = getUserDisplayName.value
  return user.value?.wechatAvatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=667eea&color=fff&size=32`
})

// 方法
const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

// 计算菜单位置的函数
const calculateMenuPosition = (buttonRef: HTMLElement) => {
  const rect = buttonRef.getBoundingClientRect()
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  
  return {
    position: 'fixed',
    top: `${rect.bottom + 8}px`,
    right: `${window.innerWidth - rect.right}px`,
    zIndex: '9999'
  }
}

// 切换题库中心菜单
const toggleQuestionBankMenu = async () => {
  isQuestionBankMenuOpen.value = !isQuestionBankMenuOpen.value
  // 关闭其他菜单
  if (isQuestionBankMenuOpen.value) {
    isMainMenuOpen.value = false
    // 计算菜单位置
    await nextTick()
    if (questionBankMenuRef.value) {
      questionBankMenuStyle.value = calculateMenuPosition(questionBankMenuRef.value)
    }
  }
}

// 切换主菜单
const toggleMainMenu = async () => {
  isMainMenuOpen.value = !isMainMenuOpen.value
  // 关闭其他菜单
  if (isMainMenuOpen.value) {
    isQuestionBankMenuOpen.value = false
    // 计算菜单位置
    await nextTick()
    if (mainMenuRef.value) {
      mainMenuStyle.value = calculateMenuPosition(mainMenuRef.value)
    }
  }
}

// 关闭所有菜单
const closeAllMenus = () => {
  isMenuOpen.value = false
  isQuestionBankMenuOpen.value = false
  isMainMenuOpen.value = false
}

const logout = async () => {
  try {
    await authStore.logout()
    closeAllMenus() // 退出登录时关闭所有菜单
    router.push('/login')
  } catch (error) {
    console.error('Logout failed:', error)
  }
}

const closeMenu = () => {
  isMenuOpen.value = false
}

// 点击外部关闭菜单
const handleClickOutside = (event: Event) => {
  const target = event.target as HTMLElement
  const mobileMenuContainer = document.querySelector('.mobile-menu-container')
  const teleportMenus = document.querySelectorAll('.teleport-menu')
  
  // 检查点击是否在菜单容器或Teleport菜单内
  let isInsideMenu = false
  
  if (mobileMenuContainer && mobileMenuContainer.contains(target)) {
    isInsideMenu = true
  }
  
  teleportMenus.forEach(menu => {
    if (menu.contains(target)) {
      isInsideMenu = true
    }
  })
  
  if (!isInsideMenu) {
    closeAllMenus()
  }
}

// 监听点击事件
onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

const handleAvatarError = (event: Event) => {
  const target = event.target as HTMLImageElement
  target.style.display = 'none'
}
</script>

<style scoped>
/* 现代化导航栏样式 */
.modern-navbar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: sticky;
  top: 0;
  z-index: 2000;
}

.modern-brand {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 1.25rem;
  text-decoration: none;
  color: white !important;
  transition: all 0.3s ease;
}

.modern-brand:hover {
  transform: translateY(-1px);
  color: rgba(255, 255, 255, 0.9) !important;
}

.brand-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 1.2rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.brand-text {
  background: linear-gradient(45deg, #ffffff, #f0f8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-family { margin-left: .25rem; color: rgba(255, 255, 255, .88); font-size: .78rem; }

@media (max-width: 575px) {
  .modern-navbar .container-fluid { flex-wrap: wrap; }
  .brand-family { order: 3; flex-basis: 100%; margin: .25rem 0 0 52px; }
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;
  border-radius: 10px;
  margin: 0 0.25rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.nav-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.nav-link:hover::before {
  left: 100%;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.nav-link.active {
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* 现代化下拉菜单样式 */
.dropdown-menu {
  min-width: 220px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  padding: 0.75rem 0;
  margin-top: 0.5rem;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;
  color: #333;
  transition: all 0.3s ease;
  border-radius: 0;
  position: relative;
  overflow: hidden;
}

.dropdown-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.dropdown-item:hover::before {
  transform: scaleY(1);
}

.dropdown-item:hover {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  color: #667eea;
  transform: translateX(5px);
}

.dropdown-item i {
  width: 20px;
  text-align: center;
}

/* 题库中心下拉菜单样式 */
.nav-item.dropdown {
  position: relative;
}

.nav-item.dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1080;
  animation: dropdownFadeIn 0.3s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 现代化用户头像样式 */
.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.user-avatar:hover {
  transform: scale(1.1);
  border-color: rgba(255, 255, 255, 0.6);
}

/* 用户信息显示样式 */
.nav-link[style*="cursor: default"] {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  padding: 0.5rem 1rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* 退出登录按钮样式 */
.nav-link.btn.btn-link {
  background: linear-gradient(135deg, rgba(220, 53, 69, 0.8), rgba(220, 53, 69, 0.6));
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  transition: all 0.3s ease;
}

.nav-link.btn.btn-link:hover {
  background: linear-gradient(135deg, rgba(220, 53, 69, 1), rgba(220, 53, 69, 0.8));
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

/* 移动端浮动菜单样式 */
.mobile-menu-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}

.mobile-dropdown {
  position: relative;
}

.mobile-menu-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
}

.mobile-menu-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.05);
}

.mobile-menu-btn.active {
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);
}

.mobile-dropdown-menu {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  padding: 0.5rem 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px) scale(0.95);
  transition: all 0.3s ease;
  z-index: 1080;
}

.mobile-dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
}

/* Teleport菜单样式 - 渲染到body的菜单 */
.mobile-dropdown-menu.teleport-menu {
  position: fixed;
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
  z-index: 9999 !important;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(25px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2);
  padding: 0.5rem 0;
  animation: teleportMenuFadeIn 0.3s ease;
}

@keyframes teleportMenuFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.mobile-dropdown-menu.main-menu {
  right: 0;
}

.mobile-dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
  border-radius: 8px;
  margin: 0.25rem 0.5rem;
  font-size: 0.9rem;
  position: relative;
  overflow: hidden;
}

.mobile-dropdown-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.mobile-dropdown-item:hover::before {
  transform: scaleY(1);
}

.mobile-dropdown-item:hover {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  color: #667eea;
  transform: translateX(5px);
}

.mobile-dropdown-item i {
  width: 20px;
  text-align: center;
}

.mobile-dropdown-item.user-info {
  background: rgba(102, 126, 234, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.2);
  cursor: default;
}

.mobile-dropdown-item.user-info:hover {
  transform: none;
}

.mobile-dropdown-item.logout-btn {
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  color: #dc3545;
}

.mobile-dropdown-item.logout-btn:hover {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

/* 响应式设计 */
@media (max-width: 991.98px) {
  .modern-navbar {
    padding: 0.5rem 1rem;
  }
  
  .brand-icon {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
  
  .brand-text {
    font-size: 1.1rem;
  }
  
  .user-avatar {
    width: 28px;
    height: 28px;
  }
}

/* 小屏幕优化 */
@media (max-width: 480px) {
  .mobile-menu-btn {
    width: 36px;
    height: 36px;
    font-size: 1rem;
  }
  
  .mobile-dropdown-menu {
    min-width: 180px;
    right: -10px;
  }
  
  .mobile-dropdown-item {
    padding: 0.6rem 0.8rem;
    font-size: 0.85rem;
  }
  
  .brand-icon {
    width: 32px;
    height: 32px;
  }
  
  .brand-text {
    font-size: 1rem;
  }
}

/* 点击外部关闭菜单的遮罩层 */
@media (max-width: 991.98px) {
  .mobile-dropdown-menu.show::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -10;
    background: transparent;
  }
}
</style>
